import { Button } from 'antd';
import { FormattedMessage } from 'react-intl';
import {
  CustomerVehicleReduced,
  CustomerVehiclesFilterParamsReduced,
} from '@/core/domain/people/CustomerVehicles/CustomerVehicles.types';
import { ColumnsType } from '@/components/_common/Table';
import { useVehiclesFilterReduced } from '@/core/domain/people/Customers/Customers.hooks';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { AppPageHeader, InfiniteTable } from '@/components/_common';
import { useState } from 'react';
import { useDebounce } from '@/hooks';

interface ModalVehiclesListProps {
  customerId?: number;
  onSelectVehicle: (vehicle: CustomerVehicleReduced) => void;
}

const ModalVehiclesList = ({
  onSelectVehicle,
  customerId,
}: ModalVehiclesListProps) => {
  const [queryParams, setQueryParams] =
    useState<CustomerVehiclesFilterParamsReduced>({
      active: true,
    });

  const queryDebounce = useDebounce(queryParams);

  const vehicleList = useVehiclesFilterReduced(
    { customerId, ...queryDebounce },
    !!customerId,
  );
  const vehiclesData = flatInfiniteData(vehicleList.data);

  const vehiclesColumns: ColumnsType<CustomerVehicleReduced> = [
    {
      dataIndex: 'licensePlate',
      title: <FormattedMessage id="diagnostics.modal.vehicles.licensePlate" />,
    },
    {
      dataIndex: 'actions',
      align: 'right',
      render: (_, row) => (
        <Button type="primary" onClick={() => onSelectVehicle(row)}>
          <FormattedMessage id="diagnostics.modal.button.select" />
        </Button>
      ),
    },
  ];

  return (
    <>
      <AppPageHeader
        onSearch={(value) =>
          setQueryParams((prev) => ({ ...prev, licensePlate: value }))
        }
      />

      <InfiniteTable<CustomerVehicleReduced>
        rowKey={(row) => row.id}
        columns={vehiclesColumns}
        dataSource={vehiclesData}
        loading={vehicleList.isLoading}
        hasNextPage={vehicleList.hasNextPage}
        fetchNextPage={vehicleList.fetchNextPage}
        isFetching={vehicleList.isFetching}
      />
    </>
  );
};

export default ModalVehiclesList;
